import React from 'react';
import PriceDisplay from 'modules/emergencies/components/ui/price-display/PriceDisplay';
import { SemaphoreInputComponent } from '@ontruck/fe-ui';

export const PriceSuggestionReadonly = ({ quoteFormBodyData }) => {
  const amount = quoteFormBodyData?.quoteDetail?.suggested_price?.amount;
  const level = quoteFormBodyData?.quoteDetail?.classification;
  const isLoading = quoteFormBodyData?.isWaitingForResponse;
  const hasErrors = quoteFormBodyData?.backendErrors?.length > 0;

  if (amount === undefined) return <></>;

  let amounthWithNodecimals = amount;

  try {
    if (amount === 0 || amount === '0.00') amounthWithNodecimals = 'N/A';
    else {
      amounthWithNodecimals = `€ ${Math.trunc(amounthWithNodecimals)}`;
    }
  } catch (e) {}

  return (
    <>
      {level && level !== '' ? (
        <SemaphoreInputComponent
          label="AI Suggested Pricing"
          value={amounthWithNodecimals}
          level={level}
          hasErrors={hasErrors}
          isLoading={isLoading}
          isReadonly={true}
        />
      ) : (
        <PriceDisplay
          label={<>Suggested price</>}
          isReadonly={true}
          hasError={false}
          isLoading={false}
          price={amounthWithNodecimals}
        />
      )}
    </>
  );
};
